import { combineReducers } from "redux";
import auth from "./auth";

const reducers = {
    auth,
};

export default combineReducers(reducers);